import {IInitialObjectWizardState} from "../../../types/ui/wizard/initial-object";

export const initialInitialObjectState: IInitialObjectWizardState = {
};
